import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getModulesSearchTerm } from 'EmailEditorUI/redux/selectors/selected';
import { DEFAULT_TILES_PER_ROW } from 'LayoutBuilderUI/components/panels/sidebar/utils/sizing';
export const useModulesSectionShowMoreProperties = modules => {
  const [shouldShowAll, setShouldShowAll] = useState(false);
  const searchTerm = useSelector(getModulesSearchTerm);
  const tilesPerTwoRows = DEFAULT_TILES_PER_ROW * 2;
  const shouldRenderShowMore = modules.length > tilesPerTwoRows && !shouldShowAll && !searchTerm;
  const displayedItems = shouldShowAll || searchTerm ? modules : modules.slice(0, tilesPerTwoRows);
  return {
    setShouldShowAll,
    shouldRenderShowMore,
    displayedItems
  };
};